import { RoomModuleMapModel } from '@common/modelDefinition';
import rest from '@data/restWrapper';
import { SRCPinCfg } from '@hwcontroller/types';

export async function getAllRoomModuleMapData(): Promise<RoomModuleMapModel[]> {
    return await rest('/RoomModuleMap', 'GET');
}

export async function getSpecificRoomModuleMap(
    roomInfoId: number,
    hwModuleId: string
): Promise<RoomModuleMapModel | null> {
    return await rest('/getSpecificRoomModuleMap/' + roomInfoId + '/' + hwModuleId, 'GET');
}

export async function addOrUpdateRoomModuleMap(roomModuleMap: RoomModuleMapModel) {
    return await rest('/addOrUpdateRoomModuleMap', 'POST', { roomModuleMap });
}

export async function getRoomAllModulesMap(roomInfoId: number): Promise<RoomModuleMapModel[]> {
    return await rest('/getRoomAllModulesMap/' + roomInfoId, 'GET');
}

export async function fetchModuleHWSettings(hwModuleUUID: string, bmsUuid: string): Promise<any> {
    console.log('TU SAM');
    return await rest('/api/BMS/v1/fetchModuleHWSettings/' + bmsUuid, 'POST', { hwModuleUUID });
}

export async function setRoomModuleSettings(BMSUUID: string, payload: any, type: string): Promise<any> {
    const _setRoomModuleSettings =  await rest(`/api/BMS/v1/setRoomModuleSettings/${BMSUUID}`, 'PUT', {
        data: payload,
        type: type,
    });
    return _setRoomModuleSettings
}

export async function setRoomModuleIOConfig(BMSUUID: string, updatedIOs: SRCPinCfg[], hwModuleUUID: string): Promise<any> {
    const _setRoomModuleIOConfig = await rest(`/api/BMS/v1/setRoomModuleIOConfig/${BMSUUID}`, 'PUT', {
        data: updatedIOs,
        id: hwModuleUUID,
    });
    return _setRoomModuleIOConfig
}

export async function setClearEeprom(BMSUUID: string, hwModuleUuid: string): Promise<any> {
    return await rest(`/api/BMS/v1/setClearEeprom/${BMSUUID}`, 'PUT', {
        id: hwModuleUuid,
    });
}

export async function setResetController(BMSUUID: string, hwModuleUuid: string): Promise<any> {
    return await rest(`/api/BMS/v1/setResetController/${BMSUUID}`, 'PUT', {
        id: hwModuleUuid,
    });
}

export async function setSyncClock(BMSUUID: string, hwModuleUuid: string): Promise<any> {
    return await rest(`/api/BMS/v1/setSyncClock/${BMSUUID}`, 'POST', {
        id: hwModuleUuid,
    });
}

export async function fetchModuleHWAccessCodes(hwModuleUUID: string, bmsUuid: string): Promise<any> {
    return await rest('/api/BMS/v1/fetchModuleHWAccessCodes/' + bmsUuid, 'POST', { hwModuleUUID });
}

export function setBmsIOConfigBroadcastSettings(data: any[], rooms: any[]) {
    const _setBmsIOConfigBroadcastSettings = rest('/api/BMS/v1/setBmsIOConfigBroadcastSettings/', 'POST', { 
        data: data,
        rooms: rooms
    });
    return _setBmsIOConfigBroadcastSettings
}

export function broadcastBmsThermostatSettings(thermValues: any, rooms: any[]) {
    return rest('/api/BMS/v1/broadcastBmsThermostatSettings/', 'POST', { 
        thermValues: thermValues,
        rooms: rooms 
    });
}
